import { Button, ListItemIcon, MenuItem, Pagination, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useEffect, useState } from "react";
import BgBox from "../../../components/BgBox";
import { customAlert } from "../../../components/notify";
import { useTranslation } from "react-i18next";

import QueryKey from '../../../QueryKey';
import { useQuery } from 'react-query';
import LoadingScreen from '../../../components/loadingScreen';
import { ArrowDropDown, ArrowDropUp, Description, FilterAlt, PictureAsPdf } from '@mui/icons-material';
import OptionMenu from '../../../components/OptionMenu';
import FilterMdl from "./FilterMdl";
import { getTpReqPymtRept } from "../../../services/trkOp-service";
import { tpReqPymtReptExcel } from "../../../services/excel-service";
import { tpReqPymtReptPdf } from "../../../services/pdf-service";
import { useAuthContext } from "../../../context/AuthContext";
import TpReqPymtReptTable from "../../../components/TpReqPymtReptTable";
import { getLast30Days } from '../../../utils/format';
import { DEFAULT_PAGE_SIZE } from '../../../constants/pagination';
import RecordCount from "../../../components/RecordCount";
import CustomDropDown from "../../../components/CustomDropDown";
import { getAllReportConfigs } from "../../../services/bo-service";


function TpReqPymtReptPage() {
  const { t } = useTranslation();
  const [pageNumber, setPageNumber] = useState(1);
  const limit = DEFAULT_PAGE_SIZE
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const { today, priorDate } = getLast30Days();
  const [filterObj, setFilterObj] = useState({
    fromDate: priorDate,
    toDate: today
  });
  // console.log({ ...filterObj })
  const { setLoadingScreen } = useAuthContext();
  const { isLoading, isFetching, isError, error, data: tpReqData } = useQuery(
    [QueryKey.tpReqPymtRepts, pageNumber, filterObj],
    () => getTpReqPymtRept({ limit, pageNumber, ...filterObj }), {
    keepPreviousData: true
  });

  useEffect(() => {
    setLoadingScreen(isFetching);
    return () => setLoadingScreen(false);
  }, [isFetching, setLoadingScreen]);

  const [filterMdl, setFilterMdl] = useState(false);
  const handleFilterMdlClose = () => setFilterMdl(false);
  const handleFilterMdlOpen = () => setFilterMdl(true);

  // SA-configured column sets for this report (falls back to the default columns below).
  const { data: rptCfgArr } = useQuery([QueryKey.reportConfigList, "tpReqPymt"], () => getAllReportConfigs("tpReqPymt"));
  const [rptCfg, setRptCfg] = useState(null);

  useEffect(() => {
    if (rptCfgArr && rptCfgArr.length > 0)
      setRptCfg(rptCfgArr[0]);
  }, [rptCfgArr]);

  function handleRptCfgChange(e) {
    const { value } = e.target;
    setRptCfg(rptCfgArr?.find((i) => i.id === value) || null);
  }

  const defaultColumns = [
    { id: "trkOp", label: "Truck Operator", minWidth: 170 },
    { id: "truckOpReqId", label: "Request Id", minWidth: 170 },
    { id: 'trkRegNo', label: "Truck Number", minWidth: 150 },
    { id: 'type', label: "Truck", minWidth: 150 },
    { id: 'createdShipmtCount', label: "Created Shipments", minWidth: 50 },
    { id: "createdShipmts", label: "Shipments", minWidth: 170 },
    { id: "basePrc", label: "Base Price", minWidth: 100 },

    { id: "aHalting", label: "Halting(+)", minWidth: 100 },
    { id: "aUlCooliDrv", label: "UL Coolie Paid by Driver(+)", minWidth: 100 },
    { id: "aLdCooliDrv", label: "Loading Coolie Paid by Driver(+)", minWidth: 100 },
    { id: "aIncidental", label: "Incidental Charges(+)", minWidth: 100 },
    { id: "aOthers", label: "Others(+)", minWidth: 50 },

    { id: "dTds", label: "TDS(-)", minWidth: 100 },
    { id: "dCommission", label: "Commission(-)", minWidth: 100 },
    { id: "dPenalty", label: "Penalty(-)", minWidth: 100 },
    { id: "dClaim", label: "Claim(-)", minWidth: 100 },
    { id: "dLdCooli", label: "Loading Coolie(-)", minWidth: 100 },
    { id: "dUlCooli", label: "Unloading Coolie(-)", minWidth: 100 },
    { id: "dFrtLess", label: "Recd Freight Less(-)", minWidth: 100 },
    { id: "dOthers", label: "Others(-)", minWidth: 100 },

    { id: "finalPricing", label: "Total", minWidth: 100 },
    { id: "pendingAmount", label: "Pending", minWidth: 100 },
  ];

  const columns = rptCfg?.config ? JSON.parse(rptCfg.config) : defaultColumns;


  const optionItems = [
    {
      title: t("bo.reptListPg.pdf"),
      icon: <PictureAsPdf fontSize="small" />,
      fn: async () => {
        setLoadingScreen(true);
        try {
          const res = await tpReqPymtReptPdf({ filterObj, columns });
          window.open(res.fileUrl, "_blank")
        } catch (err) {
          // console.log(err);
          customAlert(err)
        }
        setLoadingScreen(false);
      }
    },
    {
      title: t("bo.reptListPg.excel"),
      icon: <Description fontSize="small" />,
      fn: async () => {
        try {
          const res = await tpReqPymtReptExcel({ filterObj, columns });
          window.open(res.fileUrl, "_blank")
        } catch (err) {
          // console.log(err);
          customAlert(err)
        }
      }
    }
  ]


  const handlePageChange = async (event, value) => {
    setPageNumber(value);
  };

  function handleFilterObj(obj) {
    setPageNumber(1);
    setFilterObj({ ...obj })
  }



  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }

  if (isLoading)
    return <Box sx={{ position: "absolute", top: 0, left: 0 }}><LoadingScreen /></Box>


  const handleExportClose = () => {
    setAnchorEl(null);
  };

  const handleExportClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  return (

    <BgBox px={4} py={1}>
      <Stack direction={'row'} justifyContent="space-between" alignItems={"center"} mb={0.8} mt={2} px={2}>
        <Stack direction={'row'} alignItems={"center"}>
          <Typography variant='h5' sx={{ fontWeight: "bold", mr: 4, mb: 1 }}>{t("bo.opReqPymtReptsPg.tpReqPymtRept")}<RecordCount count={tpReqData?.totalLength} /></Typography>
        </Stack>

        <Stack direction={'row'} justifyContent="space-between" alignItems={"center"}>
          {rptCfgArr?.length > 0 &&
            <CustomDropDown key={rptCfg?.id || "none"} height={36} width={180} fontSize={13} handleDDChange={handleRptCfgChange} defaultValue={rptCfg?.id} ddArr={rptCfgArr.map((i) => ({ value: i.id, label: i.configName }))} />}
          <Button variant='outlined' sx={{ ml: 2, mb: 0.4 }} startIcon={<FilterAlt />} color='primary' onClick={handleFilterMdlOpen} >{t("bo.reptListPg.filter")}</Button>
          <Button variant='contained' sx={{ ml: 2, mb: 0.4 }} endIcon={open ? <ArrowDropUp /> : <ArrowDropDown />} color='primary' onClick={handleExportClick} >{t("bo.reptListPg.export")}</Button>

        </Stack>
      </Stack>

      <TpReqPymtReptTable tpReqData={tpReqData?.data} columns={columns} />


      <Stack sx={{ alignItems: "center", mt: 1 }}>
        <Pagination count={Math.ceil(tpReqData?.totalLength / limit) || 0} color="primary" page={pageNumber} onChange={handlePageChange} variant="outlined" shape="rounded" />
      </Stack>
      <OptionMenu open={open} handleClose={handleExportClose} anchorEl={anchorEl} >
        {optionItems.map((i) => <MenuItem sx={{ pl: 2, pr: 5 }} key={i.title} onClick={i.fn}>
          <ListItemIcon > {i.icon}</ListItemIcon>
          {i.title}
        </MenuItem>)}
      </OptionMenu>

      <FilterMdl modalOpen={filterMdl} handleModalClose={handleFilterMdlClose} filterObj={filterObj} handleFilterObj={handleFilterObj} />
    </BgBox>

  )
}

export default TpReqPymtReptPage;